import React, { useEffect } from 'react';
import IndustryHero from '../components/IndustryHero';
import Stats from '../components/Stats';
import Calculator from '../components/Calculator';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import ContactForm from '../components/ContactForm';
import SafeIcon from '../common/SafeIcon';

const IndustryPage = ({ content }) => {
  // Scroll to top whenever content changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [content?.id]);

  // If content is missing, show a fallback or redirect
  if (!content) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950 text-white pt-20">
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Industry Content Not Found</h2>
          <a href="/" className="text-blue-400 hover:underline">Return to Home</a>
        </div>
      </div>
    );
  }

  return (
    <div className="animate-in fade-in duration-700">
      <IndustryHero content={content} />
      
      {/* Industry Specific Pain Points */}
      <section className="py-20 bg-slate-900/30 border-y border-slate-800/50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-2xl font-bold text-white mb-2">Critical Challenges in {content.title}</h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto rounded-full"></div>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {content.painPoints && content.painPoints.map((point, idx) => (
              <div key={idx} className="flex gap-4 items-start p-6 bg-slate-800/40 rounded-2xl border border-slate-700/50 hover:border-blue-500/30 transition-colors">
                <div className="w-10 h-10 bg-red-500/10 rounded-lg flex items-center justify-center shrink-0">
                  <SafeIcon name="AlertCircle" className="text-red-400 text-xl" />
                </div>
                <p className="text-slate-200 font-medium leading-relaxed">{point}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pass custom stats if they exist, otherwise Stats component uses defaults */}
      <Stats customStats={content.stats} />
      
      <div id="calculator">
        <Calculator industry={content.id} />
      </div>

      <HowItWorks />
      
      <div id="pricing">
        <Pricing />
      </div>

      <div id="contact">
        <ContactForm industryName={content.title} />
      </div>
    </div>
  );
};

export default IndustryPage;